// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bdip","name":"styles_name__3ykVX","phone":"styles_phone__2pxrC"};